import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import SchoolIcon from "@mui/icons-material/School";
import useFetch from "../../../../hooks/useFetch";
import {
    EmptyState,
    Skeleton,
} from "../../../shares/dashboard/DashboardWidgets";

/**
 * Course headlines from classroom/headlines/.
 *
 * Previously a row of centred square tiles containing nothing but a title,
 * inside an overflow-y-scroll wrapper that clipped them on short viewports and
 * a map with no key prop. Now a responsive grid of cards that read as entry
 * points - icon, title, explicit affordance - so it is obvious they navigate.
 */
const ClassCard = () => {
    const [classRoom, setClassRoom] = useState();

    const fetchData = useFetch({
        method: "GET",
        url: `classroom/headlines/`,
        noHeader: false,
        trigger: true,
        setter: setClassRoom,
        errMessage: () =>
            toast.error("مشکلی در دریافت اطلاعات پیش آمده", {
                position: "bottom-left",
                rtl: true,
                autoClose: 2000,
            }),
    });

    if (fetchData.loading && !classRoom) {
        return (
            <div className="grid grid-cols-3 gap-lg max-md:grid-cols-2 max-sm:grid-cols-1">
                {[0, 1, 2, 3, 4, 5].map((key) => (
                    <Skeleton key={key} className="h-[13rem] w-full" />
                ))}
            </div>
        );
    }

    if (!classRoom?.length) {
        return (
            <EmptyState
                icon={SchoolIcon}
                title="هنوز درسی برات ثبت نشده"
                description="به‌محض اینکه درسی به گروهت اضافه بشه، همین‌جا می‌بینیش."
            />
        );
    }

    return (
        <div className="grid grid-cols-3 gap-lg max-md:grid-cols-2 max-sm:grid-cols-1">
            {classRoom.map((item, index) => (
                <Link
                    key={item.classroom_headline}
                    to={item.classroom_headline}
                    state={item.classroom_headline}
                    style={{ "--i": index }}
                    className="dash-rise group flex flex-col justify-between gap-xl rounded-panel border border-rule-subtle bg-surface p-xl shadow-card transition-shadow duration-200 hover:shadow-headerCard focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary motion-reduce:transition-none"
                >
                    <span className="flex h-[4.4rem] w-[4.4rem] items-center justify-center rounded-card bg-primary-soft text-primary">
                        <MenuBookIcon sx={{ fontSize: "2.2rem" }} />
                    </span>

                    <span className="flex items-end justify-between gap-sm">
                        <span className="min-w-0 text-lg font-semibold leading-snug text-ink">
                            {item.classroom_headline}
                        </span>
                        <span className="flex shrink-0 items-center gap-2xs text-sm text-primary">
                            جلسات
                            <ArrowBackIosNewIcon sx={{ fontSize: "1.1rem" }} />
                        </span>
                    </span>
                </Link>
            ))}
        </div>
    );
};

export default ClassCard;
